import { createAction } from '@'
import { SetFormValues } from '@form'
import { SetModalVisible } from '@modal'

export default createAction('OpenRegionEditor', async (region, supplierCode) => {
    SetFormValues('RegionCoverageEditor', {
        region_id: region.region_id,
        supplier_code: supplierCode || '',
        region_name: region.region_name || '',
        region_name_full: region.region_name_full || '',
        region_type: region.region_type || undefined,
        country_code: region.country_code || '',
        sync_from_lst_region: false
    })
    SetModalVisible('RegionCoverageEditor', true)
})
